import type { FlashStatusType } from '@/Shared/AutoGenerated/Main'

type FlashMessageListener = () => void

export interface FlashMessageTimer {
    setTimeout(callback: () => void, delayMilliseconds: number): number
    clearTimeout(timeoutIdentifier: number): void
}

export class FlashMessageStore {
    private flashStatus: FlashStatusType | null = null
    private readonly listeners = new Set<FlashMessageListener>()
    private timeoutIdentifier: number | null = null

    public constructor(private readonly timer: FlashMessageTimer) {}

    public display = (flashStatus: FlashStatusType): void => {
        this.clearTimeout()
        this.flashStatus = flashStatus
        this.notifyListeners()
        this.timeoutIdentifier = this.timer.setTimeout(this.dismiss, 5000)
    }

    public dismiss = (): void => {
        this.clearTimeout()

        if (this.flashStatus === null) {
            return
        }

        this.flashStatus = null
        this.notifyListeners()
    }

    private clearTimeout(): void {
        if (this.timeoutIdentifier === null) {
            return
        }

        this.timer.clearTimeout(this.timeoutIdentifier)
        this.timeoutIdentifier = null
    }

    private notifyListeners(): void {
        this.listeners.forEach((listener) => listener())
    }

    // ------------
    // "useSyncExternalStore" implementation
    // ------------

    public subscribe = (listener: FlashMessageListener): (() => void) => {
        this.listeners.add(listener)

        return (): void => {
            this.listeners.delete(listener)
        }
    }

    public getSnapshot = (): FlashStatusType | null => {
        return this.flashStatus
    }
}

export const flashMessageStore = new FlashMessageStore(globalThis)
